import { RootPageContainer } from './styles';

export default RootPageContainer;
